import moment from "moment";

export const ContainerList = [
    {
        id: 1,
        name: "Quarter Container",
        text: "quarter_container_recipe",
        value: 0.25
    },
    {
        id: 2,
        name: "Half Container",
        text: "half_container_recipe",
        value: 0.50
    },
    {
        id: 3,
        name: "Single Container",
        text: "single_container_recipe",
        value: 1
    },
    {
        id: 4,
        name: "Double Container",
        text: "double_container_recipe",
        value: 2
    }
]
export const ProductionTypeCategoryList = [
    {
        "intProductTypeID": 1,
        "product_type_name": "Italian Ice"
    },
    {
        "intProductTypeID": 2,
        "product_type_name": "Cream Ice"
    },
    {
        "intProductTypeID": 8,
        "product_type_name": "Sugar-Free"
    }
]
export const ProductionSheetStatus = [
    {
        id: 1,
        name: "Draft"
    },
    {
        id: 2,
        name: "Saved"
    },
    {
        id: 3,
        name: "Completed"
    },
    {
        id: 4,
        name: "Unlocked"
    }
]
export const PurchaseCategoryList = [
    {
        "intProductTypeID": 1,
        "product_type_name": "Clothes"
    },
    {
        "intProductTypeID": 2,
        "product_type_name": "Equipment"
    },
    {
        "intProductTypeID": 3,
        "product_type_name": "Coolers and Bags"
    }
]

export const ProductionSheetFilters = [
    {
        "name": "Recents",
        "value": 'recent'
    },
    {
        "name": "Favorites",
        "value": 'favorite'
    },
    {
        "name": "All",
        "value": 'all'
    },
];

export const getBuildDate = (epoch) => {
    const buildDate = moment(epoch).format("DD-MM-YYY HH:MM");
    return buildDate;
};
const emailRegex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
const mobileRegex = new RegExp(
  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
);

const nameRegex=new RegExp(/^[A-Za-z][A-Za-z-\s]*$/)

export const emailValidator = (value) =>
  emailRegex.test(value) ? "" : "Please enter a valid email.";
export const nameValidator = (value,label) =>
nameRegex.test(value) ? "" : `Please enter a valid ${label}.`;
export const mobileValidator = (value, label = "Phone Number") => {
  let message = "";
  if (value) {
    if (!mobileRegex.test(value)) {
      message = `Please enter a valid ${label}`;
    }
  } else {
    message = `Please enter ${label}`;
  }
  return message;
};

export function checkForCorporateUser(role) {
    const adminRoles = ["Franchisee", "Manager", "Treat Team"]
    return adminRoles.includes(role)
  }
  